import { useContext } from "react";

import { CampaignContext } from "../contexts/campaignContext";

export const useCurrentCampaign = () => {
  const context = useContext(CampaignContext);

  if (context === undefined) {
    throw new Error("useCampaign must be used within a CampaignProvider");
  }

  return context;
};
